import { createContext, useContext, type ReactNode } from 'react'
import type { NivelQualidade } from './qualidadeGrafica'

const ContextoQualidade = createContext<NivelQualidade>('alta')

/**
 * Leva o nível de qualidade até os modelos, para que eles escolham quanto
 * detalhe geométrico montar (segmentos de curva, chanfro, peças miúdas).
 *
 * Fica dentro do `<Canvas>`: é lá que os modelos são montados, e o nível já
 * existe no `Visualizador3D` como estado do React. Fora de um provedor, o
 * padrão é `alta` — o que testes e telas avulsas esperam ver.
 */
export function ProvedorQualidade({ nivel, children }: { nivel: NivelQualidade; children: ReactNode }) {
  return <ContextoQualidade.Provider value={nivel}>{children}</ContextoQualidade.Provider>
}

export function useNivelQualidade(): NivelQualidade {
  return useContext(ContextoQualidade)
}

/**
 * Peças miúdas (parafusos, frisos, LEDs) são as primeiras a sair: a 1,5 m de
 * distância somem na tela de qualquer jeito, e cada uma é uma chamada de
 * desenho a mais por quadro.
 */
export function useDetalhesFinos(): boolean {
  return useNivelQualidade() !== 'baixa'
}
